export const FlightPracticeTypeEnum = {
    AIRPLANE_TRAINING: {id: 1, code: 'AIRPLANE_TRAINING', nameRu: "Подготовка пилотов самолетов"},
    HELICOPTER_TRAINING: {id: 2, code: 'HELICOPTER_TRAINING', nameRu: "Подготовка пилотов вертолетов"}
}